import policy from './chatwoot_unread_ui.yaml';

export const unreadPolicy = policy;
export const UNREAD_TAB = 'unread';

const nativeId = value => {
  if (!/^[1-9]\d*$/.test(String(value))) return null;
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) ? parsed : null;
};

export const unreadScope = (accountId, config = unreadPolicy) => {
  const id = nativeId(accountId);
  return (
    config?.enabled === true &&
    config.config_version === '2026-10-15.1' &&
    id !== null &&
    Array.isArray(config.account_ids) &&
    config.account_ids.some(
      allowed => Number.isSafeInteger(allowed) && allowed === id
    )
  );
};

export const unreadMeta = (meta = {}) => {
  const supported =
    meta?.iqosa_unread_tab_enabled === true &&
    Number.isSafeInteger(meta.unread_count) &&
    meta.unread_count >= 0;
  return {
    unreadCount: supported ? meta.unread_count : 0,
    unreadTabEnabled: supported,
  };
};

export const withUnreadTab = (
  items,
  { accountId, stats, locale, conversationType },
  config = unreadPolicy
) => {
  const allIndex = items.findIndex(item => item.key === 'all');
  if (
    Boolean(conversationType) ||
    !unreadScope(accountId, config) ||
    stats?.unreadTabEnabled !== true ||
    !Number.isSafeInteger(stats.unreadCount) ||
    stats.unreadCount < 0 ||
    allIndex < 0
  ) {
    return items;
  }
  const language = String(locale || '').split(/[-_]/)[0];
  const name = config.labels?.[language] || config.labels?.en;
  if (typeof name !== 'string' || !name.trim()) return items;
  return [
    ...items.slice(0, allIndex),
    { key: UNREAD_TAB, name, count: stats.unreadCount },
    ...items.slice(allIndex),
  ];
};

// The server selects unread rows before pagination. This predicate only removes
// rows that become read through the native store after a page was received.
export const isUnreadConversation = conversation =>
  Number.isSafeInteger(conversation?.unread_count) &&
  conversation.unread_count > 0;

// Metadata counts precede the assignee filter and do not depend on page/sort.
export const unreadMetadataScope = (params = {}) =>
  JSON.stringify([
    params.inboxId || null,
    params.teamId || null,
    params.status || null,
    params.labels || [],
    params.conversationType || null,
  ]);
